import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useL10n } from "@ews/react-localization-context";

const Remarks: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>

        <SettingsTextInput
            text={t("TRVB_COMMENT_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_COMMENT_DESC")} />}
            value={specification.remarks}
            onBlur={({ value }) =>
            {
                if (specification.remarks === value) return;
                if (systemId) {
                    modifySystemSpecification(systemId, {
                        ...specification,
                        remarks: value
                    });
                }
            }
            } />
    </>;
};

export default Remarks;
